export default __webpack_public_path__ + "static/media/G0860.Breech_semirecum2.1692872820000.8d664402.jpg";